import { Divider, Container, Stack } from '@mui/material';

import { black } from '~/styles/colors';

const ErrorLayout = ({
  Alert,
  MessageLineOne,
  MessageLineTwo,
}: {
  Alert: React.FC;
  MessageLineOne: React.FC;
  MessageLineTwo: React.FC;
}) => {
  return (
    <Container
      sx={{
        justifyContent: 'center',
        display: 'flex',
        height: 'calc(100vh - 64px - 32px)',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 4,
      }}>
      <Stack direction="row" spacing={2} alignItems="center">
        <Alert />
        <Divider
          orientation="vertical"
          sx={{ borderColor: black[1000], height: 48, alignSelf: 'center' }}
          flexItem
        />
        <Stack direction="column" spacing={0.5} alignItems="flex-start">
          <MessageLineOne />
          <MessageLineTwo />
        </Stack>
      </Stack>
    </Container>
  );
};

export default ErrorLayout;
